<template>
  <div>
    <vs-button
      color="#32C040"
      icon="add_box"
      style="border-radius: 20px"
      v-b-modal.AddPart
    >
      Add Part
    </vs-button>
    <b-modal id="AddPart" centered hide-footer size="lg " scrollable="true">
      <template #modal-title>
        <h3>Add a Part</h3>
        <h5>The new Part will be...</h5>
      </template>
      <div>
        <div>
          <ul class="leftx" style="list-style-type: none">
            <li @click="status = false">
              <vs-radio
                v-model="radios1"
                vs-name="radios1"
                vs-value="default"
                style="justify-content: start"
                >A <b>Blank</b> Part
              </vs-radio>
            </li>
            <br />
            <!-- <br /> -->
            <li @click="status = true">
              <vs-radio
                v-model="radios2"
                vs-name="radios1"
                vs-value="copy"
                style="justify-content: start"
              >
                <span v-b-toggle.collapse-1>
                  A <b>Copy</b> of an Existing Part
                </span>
              </vs-radio>
            </li>
          </ul>
        </div>
        <!-- <br /> -->
        <vs-divider />
        <div v-if="status == false">
          <vs-input
            label="Please type in a name for the new part."
            v-model="part_name"
            :danger="this.dangerName"
            :danger-text="this.dangerNametext"
            style="width: 35%"
            @change="nameValidate(part_name)"
          />
          <!-- <vs-input
            label="Asset"
            v-if="part_name != null"
            v-model="asset"
            :danger="this.dangerAsset"
            :danger-text="this.dangerAssettext"
            @change="assetValidate(asset)"
            style="width: 35%"
          /> -->
          <vs-input
            label="Category"
            v-if="part_name != null"
            v-model="category"
            :danger="this.dangerCate"
            :danger-text="this.dangerCatetext"
            @change="cateValidate(category)"
            style="width: 35%"
          />
          <vs-select
            label="Location"
            v-if="category != null"
            placeholder="Select Location"
            v-model="location_id"
            style="width: 35%"
          >
            <br />
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.list.value"
              v-for="(item, index) in location"
            />
          </vs-select>
          <!-- <vs-input
            label="Open_POs"
            v-if="location_id != null"
            v-model="open_pos"
            :danger="this.dangerPOs"
            :danger-text="this.dangerPOstext"
            @change="posValidate(open_pos)"
            style="width: 35%"
          /> -->
          <vs-input
            label="part_number"
            v-if="location_id != null"
            v-model="part_number"
            type="number"
            style="width: 35%"
            min="0"
            :danger="this.dangerNumber"
            :danger-text="this.dangerNumbertext"
            @change="numberValidate(part_number)"
          />
          <vs-input
            label="Price"
            v-if="part_number != null"
            type="number"
            v-model="price"
            style="width: 35%"
            min="0"
          />
          <vs-row v-if="price != null">
            <a class="ml-1">Qty</a>
            <div class="mt-4 mr-4">
              <vs-input-number color="success" v-model="qty" min="0" />
            </div>
            <vs-input
              label="Unit"
              v-if="price != null"
              v-model="unit"
              style="width: 14.3%"
              :danger="this.dangerUni"
              :danger-text="this.dangerUnitext"
              @change="UnitValidate(unit)"
            />
          </vs-row>
          <vs-input
            label="vendor"
            v-if="unit != null"
            v-model="vendor"
            style="width: 35%"
            :danger="this.dangerVen"
            :danger-text="this.dangerVentext"
            @change="VendorValidate(vendor)"
          />
        </div>
        <div id="collapse-1" class="mt-2" v-if="status == true">
          <vs-row>
            <h6>
              Pick a Part to copy from your location or even your fellow
              manager's location
            </h6>
            <vs-spacer></vs-spacer>
            <vs-input icon="search" placeholder="Search" v-model="value1" />
          </vs-row>
          <template>
            <div ref="tree" class="dhx-container--tree"></div>
          </template>
        </div>
      </div>
      <template>
        <vs-row class="ml-3 mt-5" vs-w="12">
          <vs-spacer />
          <vs-button
            type="filled"
            size="sm"
            style="border-radius: 20px; width: 10%"
            color="success"
            @click="Addpart()"
          >
            Add
          </vs-button>
          <b-button
            class="ml-2 mr-4"
            id="btncancel"
            variant="light"
            style="border-radius: 20px"
            @click="$bvModal.hide('AddPart')"
          >
            Cancel
          </b-button>
        </vs-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "btnAddPart",
  data() {
    return {
      dangerName: false,
      // dangerAsset: false,
      dangerCate: false,
      // dangerPOs: false,
      dangerVen: false,
      dangerUni: false,
      dangerNumber: false,
      dangerNametext: "",
      // dangerAssettext: "",
      dangerCatetext: "",
      dangerPOstext: "",
      dangerVentext: "",
      dangerUnitext: "",
      dangerNumbertext: "",
      tree: null,
      part_name: null,
      asset: [],
      location_id: null,
      category: null,
      // open_pos: null,
      part_number: null,
      price: null,
      qty: 0,
      vendor: null,
      unit: null,
      radios1: "default",
      status: false,
    };
  },
  props: {
    location,
  },
  methods: {
    Addpart() {
      let body = {
        name: this.part_name,
        // asset: Array(this.asset),
        category: this.category,
        location_id: this.location_id,
        // open_pos: this.open_pos,
        parts_name: this.part_name,
        parts_number: this.part_number,
        price: this.price,
        qty: this.qty,
        unit: this.unit,
        vendor: this.vendor,
      };
      console.log(body,"body");
      this.$API.post("parts/create", body).then((res) => {
        return res;
      });
      setTimeout(() => {
        location.reload();
      }, 500);
    },
    nameValidate(data) {
      if (data.length > 20) {
        this.dangerName = true;
        this.dangerNametext = "Part Name must be less than 20 characters";
      } else if (data == "") {
        this.dangerName = true;
        this.dangerNametext = "Part Name is required";
      } else {
        this.dangerName = false;
      }
    },
    numberValidate(data) {
      if (data.length <= 4) {
        this.dangerNumber = true;
        this.dangerNumbertext = "Part Number must be more than 4 characters";
      } else {
        this.dangerNumber = false;
      }
    },
    // assetValidate(data) {
    //   if (data.length > 20) {
    //     this.dangerAsset = true;
    //     this.dangerAssettext = "Asset must be less than 20 characters";
    //   } else if (data == "") {
    //     this.dangerAsset = true;
    //     this.dangerAssettext = "Asset is required";
    //   } else {
    //     this.dangerAsset = false;
    //   }
    // },
    cateValidate(data) {
      if (data.length > 20) {
        this.dangerCate = true;
        this.dangerCatetext = "Category must be less than 20 characters";
      } else if (data == "") {
        this.dangerCate = true;
        this.dangerCatetext = "Category is required";
      } else {
        this.dangerCate = false;
      }
    },
    // posValidate(data) {
    //   if (data.length > 20) {
    //     this.dangerPOs = true;
    //     this.dangerPostext = "Open POs must be less than 20 characters";
    //   } else if (data == "") {
    //     this.dangerPOs = true;
    //     this.dangerPOstext = "Open POs is required";
    //   } else {
    //     this.dangerPOs = false;
    //   }
    // },
    UnitValidate(data) {
      if (data.length > 20) {
        this.dangerUni = true;
        this.dangerUnitext = "Unit must be less than 20 characters";
      } else if (data == "") {
        this.dangerUni = true;
        this.dangerUnitext = "Unit is required";
      } else {
        this.dangerUni = false;
      }
    },
    VendorValidate(data) {
      if (data.length > 20) {
        this.dangerVen = true;
        this.dangerVentext = "Vendor must be less than 20 characters";
      } else if (data == "") {
        this.dangerVen = true;
        this.dangerVentext = "Vendor is required";
      } else {
        this.dangerVen = false;
      }
    },
  },
};
</script>

<style>
</style>